// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"47247fd3","126":"2896f16b","255":"d17ebc59","282":"98b830fe","340":"d05864fb","484":"4ced79ae","592":"232abddb","787":"b9a571fb","790":"8ab87a4f","881":"f8ec5165","970":"156ec540"}[chunkId] + ".chunk.js";
};